<template>
    <div v-if="isMobile" class="d-flex">
        <CatalogClearFiltersItem
            v-if="selected.type_id > 0 && selected.type_id <= 500"
            :label="selected.type_name"
            :value="undefined"
            :link="selected.type_url"
            :isMobile="isMobile"
            url-param="tipo"
        />
        <CatalogClearFiltersItem
            v-if="selected.category > 0"
            :label="selected.category_name"
            :value="undefined"
            :isMobile="isMobile"
            url-param="categoria"
        />
        <CatalogClearFiltersItem
            v-if="selected.model"
            :label="selected.model_name"
            :value="undefined"
            :isMobile="isMobile"
            url-param="modelagem"
        />

        <CatalogClearFiltersItem
            v-if="selected.color"
            :label="selected.color_name"
            :value="undefined"
            :isMobile="isMobile"
            url-param="cor"
        />

        <CatalogClearFiltersItem
            v-if="selected.size"
            :label="selected.size"
            :value="undefined"
            :isMobile="isMobile"
            url-param="tamanho"
        />

        <CatalogClearFiltersItem
            v-if="selected.price"
            :label="selected.price_name"
            :value="undefined"
            :isMobile="isMobile"
            url-param="preco"
        />
    </div>
    <div v-else class="d-flex" :style="{ flexDirection: 'column' }">
        <CatalogClearFiltersItem
            v-if="selected.model"
            :label="`Modelo: ${selected.model_name}`"
            :isMobile="isMobile"
            :value="undefined"
            url-param="modelagem"
        />
        <CatalogClearFiltersItem
            v-if="selected.size"
            :label="`Tamanho: ${selected.size}`"
            :value="undefined"
            url-param="tamanho"
        />
    </div>
</template>

<script>
    import CatalogClearFiltersItem from './CatalogClearFiltersItem.vue';
    export default {
        name: 'CatalogClearFilters',
        components: {
            CatalogClearFiltersItem,
        },
        props: {
            selected: {
                type: Object,
                required: true,
            },
            isMobile: Boolean,
        },
    };
</script>
